export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-4">
          投稿爆料
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-lg mx-auto">
          你手上有独家猛料？欢迎向我们投稿！无论是娱乐圈内幕、社会热点线索还是网红八卦，你的爆料可能成为下一个全网热搜。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="mailto:tougao@51chigua.com"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-bold text-sm rounded-xl hover:bg-primary-600 transition-all duration-200 shadow-md"
          >
            <i className="ri-mail-send-line"></i>
            邮件投稿
          </a>
          <a
            href="#contact"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-700 font-bold text-sm rounded-xl border-2 border-background-300 hover:border-primary-300 hover:text-primary-600 transition-all duration-200"
          >
            <i className="ri-wechat-line"></i>
            微信爆料
          </a>
        </div>
        <p className="text-foreground-400 text-xs mt-5">投稿内容经核实后将署名发布，严格保护爆料人隐私</p>
      </div>
    </section>
  );
}